import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react'


const ImageWithLoading = ({ src, customOnLoad, style }) => {
  const [isLoaded, setIsloaded] = useState(false)

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      setIsloaded(true)
      if (customOnLoad)
        customOnLoad()
    }
    image.src = src;
  }, [])


  return (
    isLoaded
      ? <img alt="Image" src={src} style={style} />
      : <div style={{ paddingTop: '10px'}}><CircularProgress /></div>
  )
}

export default ImageWithLoading